// extracted by mini-css-extract-plugin
export default {"container":"style_container__Eg+JS","innerContainer":"style_innerContainer__+cK4d","slideAnimation":"style_slideAnimation__I+tWN","imgContainer":"style_imgContainer__B82OR"};